export const GET_ONE_PROSPECT = 'app/EditProspectHousehold/GET_ONE_PROSPECT';
export const GET_ONE_PROSPECT_SUCCESS = 'app/EditProspectHousehold/GET_ONE_PROSPECT_SUCCESS';
export const GET_ONE_PROSPECT_ERROR = 'app/EditProspectHousehold/GET_ONE_PROSPECT_ERROR';

export const EDIT_PROSPECT_HOUSEHOLD = 'app/EditProspectHousehold/EDIT_PROSPECT_HOUSEHOLD';
export const EDIT_PROSPECT_HOUSEHOLD_SUCCESS = 'app/EditProspectHousehold/EDIT_PROSPECT_HOUSEHOLD_SUCCESS';
export const EDIT_PROSPECT_HOUSEHOLD_ERROR = 'app/EditProspectHousehold/EDIT_PROSPECT_HOUSEHOLD_ERROR';

export const CLEAN = 'app/EditProspectHousehold/CLEAN';
